import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { Press as PressContent } from '#src/Press/index.tsx';

export const Press = () => {
  return (
    <AppLayout>
      <PressContent />
    </AppLayout>
  );
};

export default Press;
